module.exports = __webpack_public_path__ + "img/reset_power_step_1.ba6ac593.png";